module.exports = __webpack_public_path__ + "static/media/404.9ba4b7cb.jpg";